import { useLang } from "@/context/LangContext";

export const SEARCH_KEYWORDS = [
  "piattaforma marketing", "web scraping", "adv web", "social ads", "email marketing massivo", "social media management",
  "post programmati", "pop-up banner", "grafica web", "digital marketing tools", "automazione marketing", "lead generation",
  "social media planner", "banner generator",
];

const labels = (tr) => [
  tr("piattaforma marketing", "marketing platform"), tr("web scraping", "web scraping"), tr("adv web", "web ads"), tr("social ads", "social ads"),
  tr("email marketing massivo", "bulk email marketing"), tr("social media management", "social media management"),
  tr("post programmati", "scheduled posts"), tr("pop-up banner", "pop-up banner"), tr("grafica web", "web graphics"),
  tr("digital marketing tools", "digital marketing tools"), tr("automazione marketing", "marketing automation"),
  tr("lead generation", "lead generation"), tr("social media planner", "social media planner"), tr("banner generator", "banner generator"),
];

export const ServiceKeywords = ({ onPick }) => {
  const { tr } = useLang();
  const names = labels(tr);
  return (
    <div data-testid="service-keywords" className="flex flex-wrap items-center gap-2 mt-6">
      <span className="text-[10px] uppercase tracking-widest font-mono text-[#71717a] mr-1">{tr("Cerca un servizio", "Find a service")}</span>
      {SEARCH_KEYWORDS.map((k, i) => (
        <button key={k} type="button" data-testid={`keyword-chip-${i}`} onClick={() => onPick?.(k)}
          className="px-2.5 py-1 text-[11px] border border-[#d4d4d8] text-[#3f3f46] hover:border-[#E0262C] hover:text-[#E0262C] transition-colors">
          {names[i]}
        </button>
      ))}
    </div>
  );
};
